module.exports = __webpack_public_path__ + "media/images/front/team-a06e14c1bf892757666297b51e906907.jpg";